/* Gallery 53 — PDP image lightbox. Click a product image to open a full-screen
   view; arrows / swipe / arrow-keys move through the product's images; Esc,
   backdrop-click or × closes. Reads images straight from the Atelier gallery
   (.atl-pdp-slide__img / .atl-pdp-hero__img) and requests a larger render. */
(() => {
  if (window.__atlPdpZoom) return;
  window.__atlPdpZoom = true;

  const init = () => {
    const galleries = document.querySelectorAll('[data-pdp-gallery]');
    if (!galleries.length) return;

    const lb = document.createElement('div');
    lb.className = 'atl-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product image viewer');
    lb.hidden = true;
    lb.innerHTML =
      '<button class="atl-lightbox__close" type="button" aria-label="Close">×</button>' +
      '<button class="atl-lightbox__nav atl-lightbox__nav--prev" type="button" aria-label="Previous image">‹</button>' +
      '<figure class="atl-lightbox__stage"><img class="atl-lightbox__img" alt=""></figure>' +
      '<button class="atl-lightbox__nav atl-lightbox__nav--next" type="button" aria-label="Next image">›</button>' +
      '<div class="atl-lightbox__counter" aria-hidden="true"></div>';
    document.body.appendChild(lb);

    const lbImg = lb.querySelector('.atl-lightbox__img');
    const lbCounter = lb.querySelector('.atl-lightbox__counter');
    const btnPrev = lb.querySelector('.atl-lightbox__nav--prev');
    const btnNext = lb.querySelector('.atl-lightbox__nav--next');
    const btnClose = lb.querySelector('.atl-lightbox__close');

    let items = [];
    let index = 0;
    let lastFocus = null;

    const hiRes = (url, w) => {
      try {
        const u = new URL(url, location.href);
        u.searchParams.set('width', w || 2048);
        u.searchParams.delete('height');
        return u.toString();
      } catch (e) { return url; }
    };

    const render = () => {
      const it = items[index];
      if (!it) return;
      lbImg.src = it.src;
      lbImg.alt = it.alt || '';
      const multi = items.length > 1;
      lbCounter.textContent = multi ? (index + 1) + ' / ' + items.length : '';
      btnPrev.hidden = !multi;
      btnNext.hidden = !multi;
    };
    const open = (list, i) => {
      items = list; index = i;
      lastFocus = document.activeElement;
      render();
      lb.hidden = false;
      document.documentElement.classList.add('atl-lightbox-open');
      requestAnimationFrame(() => lb.classList.add('is-open'));
      btnClose.focus();
    };
    const close = () => {
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('atl-lightbox-open');
      let done = false;
      const finish = () => { if (done) return; done = true; lb.hidden = true; lbImg.src = ''; lb.removeEventListener('transitionend', finish); };
      lb.addEventListener('transitionend', finish);
      setTimeout(finish, 340);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    const prev = () => { if (items.length < 2) return; index = (index - 1 + items.length) % items.length; render(); };
    const next = () => { if (items.length < 2) return; index = (index + 1) % items.length; render(); };

    btnPrev.addEventListener('click', (e) => { e.stopPropagation(); prev(); });
    btnNext.addEventListener('click', (e) => { e.stopPropagation(); next(); });
    btnClose.addEventListener('click', (e) => { e.stopPropagation(); close(); });
    lb.addEventListener('click', (e) => {
      if (e.target === lb || e.target.classList.contains('atl-lightbox__stage')) close();
    });
    document.addEventListener('keydown', (e) => {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') prev();
      else if (e.key === 'ArrowRight') next();
    });

    let tx = 0, ty = 0;
    lb.addEventListener('touchstart', (e) => { const t = e.changedTouches[0]; tx = t.clientX; ty = t.clientY; }, { passive: true });
    lb.addEventListener('touchend', (e) => {
      const t = e.changedTouches[0];
      const dx = t.clientX - tx, dy = t.clientY - ty;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) { next(); } else { prev(); } }
    }, { passive: true });

    galleries.forEach((gallery) => {
      const imgs = Array.from(gallery.querySelectorAll('.atl-pdp-slide__img, .atl-pdp-hero__img'));
      if (!imgs.length) return;
      const build = () => imgs.map((im) => ({ src: hiRes(im.currentSrc || im.src), alt: im.alt }));
      imgs.forEach((im, i) => {
        im.classList.add('atl-zoomable');
        im.addEventListener('click', (e) => { e.preventDefault(); open(build(), i); });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
